'use client';
var root = globalThis;
if (root.__PlasmicContextRegistry == null) {
    root.__PlasmicContextRegistry = [];
}
function registerGlobalContext(component, meta) {
    // Check for duplicates
    if (root.__PlasmicContextRegistry.some(function (r) {
        return r.component === component && r.meta.name === meta.name;
    })) {
        return;
    }
    root.__PlasmicContextRegistry.push({ component: component, meta: meta });
}

export { registerGlobalContext as default };
//# sourceMappingURL=index.esm.js.map
